module.exports = __webpack_public_path__ + "img/AEC.9c998cef.jpg";